<template>
  <el-table
    :data="data"
    size="mini"
    stripe
    :height="600"
    style="width: 100%;"
    :row-class-name="tableClass"
  >
    <el-table-column
      label="Full Name"
      prop="Full Name"
      min-width="120px"
      show-overflow-tooltip
      sortable
    />
    <el-table-column
      label="Display Name"
      prop="Display Name"
      min-width="120px"
      show-overflow-tooltip
      sortable
    />
    <el-table-column
      label="Phone"
      prop="Phone"
      min-width="120px"
      show-overflow-tooltip
      sortable
    />
    <el-table-column
      label="Email"
      prop="Email"
      min-width="120px"
      show-overflow-tooltip
      sortable
    />
    <el-table-column
      label="Position"
      prop="Position"
      min-width="120px"
      show-overflow-tooltip
      sortable
    />
    <el-table-column
      label="Timezone"
      prop="Timezone"
      min-width="120px"
      show-overflow-tooltip
      sortable
    />
    <el-table-column
      label="Status"
      prop="status"
      min-width="50px"
      show-overflow-tooltip
      sortable
    />
  </el-table>
</template>
<script>
export default {
  name: 'Table',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    tableClass ({ row }) {
      return row.status === 'success' ? 'complete-row' : ''
    }
  }
}
</script>
<style scoped>
.complete-row {
  background-color: #f0f9eb; /* Light green background for completed rows */
}
</style>
